import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  KeyboardView,
  Title,
  ContentfulRichText,
  Copy,
  Button
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";
class PausedPlanPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps) {}

  render() {
    const { cancel_page, cancel_center_content, device } = this.props;
    return (
      <Wrapper style={{ flex: 1 }}>
        <Header
          title={cancel_page.title}
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => {
            this.props.setSecondCancelReason(null);
          }}
        />
        <KeyboardView
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Wrapper
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              margin: device == "desktop" ? "0px auto" : 0
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: 650,
                padding: 20
              }}
            >
              <Wrapper style={{ paddingTop: 20, paddingBottom: 20 }}>
                <Title style={{ textAlign: "center", marginBottom: 10 }}>
                  {cancel_center_content.pausedPlanTitle}
                </Title>
                <ContentfulRichText
                  style={{ textAlign: "center" }}
                  richText={cancel_center_content.pausedPlanDescription}
                />
              </Wrapper>
              <Wrapper style={{ paddingBottom: 40 }}>
                <PillButton
                  primary={true}
                  onPress={() => {
                    this.props.updatePlan({
                      token: this.props.token,
                      type: "pause_plan",
                      slug: cancel_page.engine_slug,
                      onSuccess: () => {
                        this.props.handleBack();
                        this.props.appRedirect({
                          redirect: "canceled"
                        });
                      }
                    });
                  }}
                >
                  {cancel_center_content.pausedPlanButtonText}
                </PillButton>
                <Button
                  style={{
                    padding: 15,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onPress={() => {
                    this.props.optOutOfPaused(true);
                  }}
                >
                  <Copy>
                    {cancel_center_content.pausedPlanSecondaryButtonText}
                  </Copy>
                </Button>
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </KeyboardView>
      </Wrapper>
    );
  }
}

export default PausedPlanPage;
